import { render, staticRenderFns } from "./criteriosImovirtual.vue?vue&type=template&id=3372e404"
import script from "./criteriosImovirtual.vue?vue&type=script&lang=js"
export * from "./criteriosImovirtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports